import { PatchMap, TileMap } from "./tile";
export class Game {
    metadata;
    script;
    tileMap;
    patchMap;
    markers;
    solidTiles;
    constructor(metadata = { title: "Empty Game", description: "An empty game" }, script = "", tileMap = null, patchMap = null) {
        this.metadata = metadata;
        this.script = script;
        this.tileMap = tileMap ? TileMap.Copy(tileMap) : new TileMap({ w: 12, h: 16 });
        this.patchMap = patchMap ? PatchMap.Copy(patchMap) : new PatchMap({ w: 1, h: 1 });
        this.markers = [];
        this.solidTiles = [];
    }
}
